import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function Splash() {
  const navigate = useNavigate();
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 100);
    const t2 = setTimeout(() => setPhase(2), 550);
    const t3 = setTimeout(() => setPhase(3), 850);
    const t4 = setTimeout(() => setPhase(4), 1150);
    const t5 = setTimeout(() => navigate("/welcome"), 1950);
    return () => [t1, t2, t3, t4, t5].forEach(clearTimeout);
  }, [navigate]);

  return (
    <div className="fixed inset-0 flex items-center justify-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #FFF4E8 0%, #fdebd0 100%)" }}>

      {/* Decorative blobs */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={phase >= 1 ? { scale: 1, opacity: 0.25 } : {}}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="absolute -top-24 -right-24 w-72 h-72 rounded-full pointer-events-none"
        style={{ backgroundColor: "#B9F85A" }}
      />
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={phase >= 1 ? { scale: 1, opacity: 0.2 } : {}}
        transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
        className="absolute -bottom-20 -left-20 w-56 h-56 rounded-full pointer-events-none"
        style={{ backgroundColor: "#FF6B4A" }}
      />

      {/* Swapping mini-cards */}
      <motion.div
        initial={{ x: -80, y: -40, opacity: 0, rotate: -12 }}
        animate={phase >= 2 ? { x: 60, y: 50, opacity: 1, rotate: 5 } : {}}
        transition={{ duration: 0.55, ease: [0.34, 1.2, 0.64, 1] }}
        className="absolute w-16 h-10 rounded-xl border-2 flex items-center justify-center text-xs font-bold"
        style={{ backgroundColor: "#B9F85A", borderColor: "#B9F85A", color: "#101828" }}
      >
        CV
      </motion.div>
      <motion.div
        initial={{ x: 80, y: 40, opacity: 0, rotate: 10 }}
        animate={phase >= 2 ? { x: -55, y: -50, opacity: 1, rotate: -6 } : {}}
        transition={{ duration: 0.55, ease: [0.34, 1.2, 0.64, 1] }}
        className="absolute w-20 h-10 rounded-xl border-2 flex items-center justify-center text-xs font-bold"
        style={{ backgroundColor: "#A7D8FF", borderColor: "#A7D8FF", color: "#101828" }}
      >
        Python
      </motion.div>

      {/* Logo */}
      <div className="text-center z-10 flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={phase >= 1 ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.45, ease: [0.34, 1.3, 0.64, 1] }}
        >
          <span className="text-6xl font-black tracking-tighter" style={{ color: "#101828" }}>Swap</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={phase >= 2 ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.35 }}
          className="mt-0.5"
        >
          <span className="text-2xl font-bold" style={{ color: "#FF6B4A" }}>Talence</span>
        </motion.div>

        <motion.div
          initial={{ scaleX: 0, originX: 0 }}
          animate={phase >= 3 ? { scaleX: 1 } : {}}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="h-0.5 w-20 rounded-full mt-2"
          style={{ backgroundColor: "#B9F85A" }}
        />

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={phase >= 4 ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.3 }}
          className="mt-5 flex items-center gap-1.5 px-3 py-1.5 rounded-full"
          style={{ backgroundColor: "#101828" }}
        >
          <span className="text-xs font-bold" style={{ color: "#B9F85A" }}>↔</span>
          <span className="text-xs font-semibold text-white">skills · aide · activités</span>
        </motion.div>
      </div>
    </div>
  );
}